import { Alert, Box, CircularProgress, Grid } from "@mui/material";

import { useGetContrato } from "@/shared/actions/erp";
import AgendamientoOrdenServicioVision360 from "@/erp/orden-servicio/orden-servicio-visita/components/save-agendamiento-orden-visita/AgendamientoOrdenServicioVision360";

/**
 * "Visión 360 del Cliente" para la activación de un TRASLADO (mismo panel que
 * usa Operaciones en visitas/traslados). Resuelve el contrato completo (con
 * cliente_data) a partir de la OT y delega en el panel compartido.
 */
export default function Vision360TrasladoCard({ ordenTrabajo }: { ordenTrabajo: any }) {
  const idContrato: string =
    ordenTrabajo?.contrato_data?.id_contrato ||
    ordenTrabajo?.agendamiento_data?.contrato_data?.id_contrato ||
    "";
  const { data, isLoading } = useGetContrato(idContrato, !!idContrato);
  const contrato: any = (data as any)?.data ?? null;

  if (!idContrato) {
    return (
      <Alert severity="info" variant="outlined">
        Sin contrato asociado para consultar el Visión 360.
      </Alert>
    );
  }
  if (isLoading && !contrato) {
    return (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }
  return (
    <Grid container>
      <AgendamientoOrdenServicioVision360 contrato={contrato || undefined} />
    </Grid>
  );
}
